export enum UserEvent {
    SIGN_IN = 'SIGN_IN',
    SIGN_OUT = 'SIGN_OUT',
    PROFILE_UPDATE = 'PROFILE_UPDATE',
}
